import React from 'react';
import { connect } from 'react-redux';
import { Translate, I18n } from 'react-redux-i18n';
import Switch from 'react-ios-switch';
import InputMask from 'react-input-mask';
import HeaderComponent from '../components/table/header/headerComponent';
import ROUTES from '../data/routes';
import { history } from '../routers/AppRouter';
import NewRegistersAction from '../app/store/actions/newRegisters';

class RegisterMonitorEdit extends React.PureComponent {
  constructor(props) {
    super(props);

    const { location } = this.props;
    const { item } = location;

    if (item) {
      this.state = {
        success: '',
        message: '',
        newRegister: item,
        typeDoc: item.typeDoc,
        email: item.email,
        cnpj: item.cnpj,
        cep: item.cep,
        address: item.address,
        number: item.number,
        complement: item.complement,
        district: item.district,
        city: item.city,
        state: item.state,
        country: item.country,
        firstName: item.firstName,
        lastName: item.lastName,
        phone: item.phone,
        role: item.role,
        sector: item.sector,
        companyName: item.companyName,
        stateRegistration: item.stateRegistration,
        purpose: item.purpose,
        business: item.business,
        naoContribIcms: item.naoContribIcms,
        icmsIsento: item.icmsIsento,
        icmsDiferido: item.icmsDiferido,
        pisCofins: item.pisCofins,
        ipi: item.ipi,
        proEmprego: item.proEmprego,
        codEmitente: item.codEmitente,
        idContato: item.idContato,
        createdAt: item.createdAt,
        updatedAt: item.updatedAt,
      };
    }
  }

  findComboName = (id, type = '') => {
    try {
      const { contact } = this.props.settings;
      let value = '';
      if (!contact) return '';

      if (type === 'business' && contact.business) {
        value = contact.business.find(it => it.id === parseInt(id, 10));
        return value ? value.name : '';
      }
      if (type === 'roles' && contact.roles) {
        value = contact.roles.find(it => it.id === parseInt(id, 10));
        return value ? value.name : '';
      }
      if (type === 'sectors' && contact.sectors) {
        value = contact.sectors.find(it => it.id === parseInt(id, 10));
        return value ? value.name : '';
      }
      return '';
    } catch (e) {
      return '';
    }
  }

  updateNewRegister = async () => {
    const {
      newRegister, cep, address, number, complement,
      district, city, state, country, firstName, lastName,
      phone, companyName, stateRegistration,
    } = this.state;

    try {
      await this.props.updateNewRegister({
        registerId: newRegister.id,
        cep,
        address,
        number,
        complement,
        district,
        city,
        state,
        country,
        firstName,
        lastName,
        phone,
        companyName,
        stateRegistration,
      });

      await this.setState({ message: '', success: I18n.t('newRegisterUpdate') });
    } catch (err) {
      await this.setState({ message: I18n.t('newRegisterUpdateError'), success: '' });
    }
  }

  renderForm = () => {
    const {
      email, cnpj, cep, address, number, complement,
      district, city, state, country, firstName, lastName,
      phone, role, sector, companyName, stateRegistration,
      purpose, business, naoContribIcms, icmsIsento, icmsDiferido,
      pisCofins, ipi, proEmprego, codEmitente, idContato,
      createdAt, updatedAt, typeDoc,
    } = this.state;

    return (
      <React.Fragment>
        <div className="form-group">
          <p className="margin-bottom-2"><Translate value="email" /></p>
          <input
            readOnly
            type="text"
            className="form-control"
            placeholder=""
            value={email || ''}
          />
        </div>
        {typeDoc === 'cnpj' ? (
          <div className="form-group">
            <p className="margin-bottom-2"><Translate value="cnpj" /></p>
            <InputMask
              readOnly
              mask="99.999.999/9999-99"
              value={cnpj || ''}
            >
              {inputProps => (
                <input
                  {...inputProps}
                  readOnly
                  type="text"
                  className="form-control"
                  style={{ marginTop: '10px' }}
                />
              )}
            </InputMask>
          </div>
        ) : (
          <div className="form-group">
            <p className="margin-bottom-2"><Translate value="cpf" /></p>
            <InputMask
              readOnly
              mask="999.999.999-99"
              value={cnpj || ''}
            >
              {inputProps => (
                <input
                  {...inputProps}
                  readOnly
                  type="text"
                  className="form-control"
                  style={{ marginTop: '10px' }}
                />
              )}
            </InputMask>
          </div>
        )}
        <div className="form-group">
          <p className="margin-bottom-2"><Translate value="cep" /></p>
          <InputMask
            readOnly
            mask="99.999-999"
            value={cep || ''}
          >
            {inputProps => (
              <input
                {...inputProps}
                readOnly
                type="text"
                className="form-control"
                style={{ marginTop: '10px' }}
              />
            )}
          </InputMask>
        </div>
        <div className="form-group">
          <p className="margin-bottom-2"><Translate value="address" /></p>
          <input
            type="text"
            className="form-control"
            placeholder=""
            value={address || ''}
            onChange={e => this.setState({ address: e.target.value })}
          />
        </div>
        <div className="form-group">
          <p className="margin-bottom-2"><Translate value="number" /></p>
          <input
            type="text"
            className="form-control"
            placeholder=""
            value={number || ''}
            onChange={e => this.setState({ number: e.target.value })}
          />
        </div>
        <div className="form-group">
          <p className="margin-bottom-2"><Translate value="complement" /></p>
          <input
            type="text"
            className="form-control"
            placeholder=""
            value={complement || ''}
            onChange={e => this.setState({ complement: e.target.value })}
          />
        </div>
        <div className="form-group">
          <p className="margin-bottom-2"><Translate value="district" /></p>
          <input
            type="text"
            className="form-control"
            placeholder=""
            value={district || ''}
            onChange={e => this.setState({ district: e.target.value })}
          />
        </div>
        <div className="form-group">
          <p className="margin-bottom-2"><Translate value="city" /></p>
          <input
            type="text"
            className="form-control"
            placeholder=""
            value={city || ''}
            onChange={e => this.setState({ city: e.target.value })}
          />
        </div>
        <div className="form-group">
          <p className="margin-bottom-2"><Translate value="state" /></p>
          <input
            type="text"
            className="form-control"
            placeholder=""
            value={state || ''}
            onChange={e => this.setState({ state: e.target.value })}
          />
        </div>
        <div className="form-group">
          <p className="margin-bottom-2"><Translate value="country" /></p>
          <input
            type="text"
            className="form-control"
            placeholder=""
            value={country || ''}
            onChange={e => this.setState({ country: e.target.value })}
          />
        </div>
        <div className="form-group">
          <p className="margin-bottom-2"><Translate value="name" /></p>
          <input
            type="text"
            className="form-control"
            placeholder=""
            value={firstName || ''}
            onChange={e => this.setState({ firstName: e.target.value })}
          />
        </div>
        <div className="form-group">
          <p className="margin-bottom-2"><Translate value="lastName" /></p>
          <input
            type="text"
            className="form-control"
            placeholder=""
            value={lastName || ''}
            onChange={e => this.setState({ lastName: e.target.value })}
          />
        </div>
        <div className="form-group">
          <p className="margin-bottom-2"><Translate value="phone" /></p>
          <input
            type="text"
            className="form-control"
            placeholder=""
            value={phone || ''}
            onChange={e => this.setState({ phone: e.target.value })}
          />
        </div>
        {typeDoc === 'cnpj' && (
          <div>
            <div className="form-group">
              <p className="margin-bottom-2"><Translate value="role" /></p>
              <input
                readOnly
                type="text"
                className="form-control"
                placeholder=""
                value={this.findComboName(role, 'roles')}
              />
            </div>
            <div className="form-group">
              <p className="margin-bottom-2"><Translate value="sector" /></p>
              <input
                readOnly
                type="text"
                className="form-control"
                placeholder=""
                value={this.findComboName(sector, 'sectors')}
              />
            </div>
            <div className="form-group">
              <p className="margin-bottom-2"><Translate value="company" /></p>
              <input
                type="text"
                className="form-control"
                placeholder=""
                value={companyName || ''}
                onChange={e => this.setState({ companyName: e.target.value })}
              />
            </div>
            <div className="form-group">
              <p className="margin-bottom-2"><Translate value="stateRegistration" /></p>
              <input
                type="text"
                className="form-control"
                placeholder=""
                value={stateRegistration || ''}
                onChange={e => this.setState({ stateRegistration: e.target.value })}
              />
            </div>
            <div className="form-group">
              <p className="margin-bottom-2"><Translate value="purpose" /></p>
              <input
                readOnly
                type="text"
                className="form-control"
                placeholder=""
                value={purpose || ''}
              />
            </div>
            <div className="form-group">
              <p className="margin-bottom-2"><Translate value="business" /></p>
              <input
                readOnly
                type="text"
                className="form-control"
                placeholder=""
                value={this.findComboName(business, 'business')}
              />
            </div>
            <div className="form-group">
              <p className="margin-bottom-2"><Translate value="naoContribIcms" /></p>
              <Switch
                readOnly
                checked={naoContribIcms}
                className="margin-bottom-2"
                onChange={value => this.setState({ naoContribIcms: !!value })}
              />
            </div>
            <div className="form-group">
              <p className="margin-bottom-2"><Translate value="icmsIsento" /></p>
              <Switch
                readOnly
                checked={icmsIsento}
                className="margin-bottom-2"
                onChange={value => this.setState({ icmsIsento: !!value })}
              />
            </div>
            <div className="form-group">
              <p className="margin-bottom-2"><Translate value="icmsDiferido" /></p>
              <Switch
                readOnly
                checked={icmsDiferido}
                className="margin-bottom-2"
                onChange={value => this.setState({ icmsDiferido: !!value })}
              />
            </div>
            <div className="form-group">
              <p className="margin-bottom-2"><Translate value="pisCofins" /></p>
              <Switch
                readOnly
                checked={pisCofins}
                className="margin-bottom-2"
                onChange={value => this.setState({ pisCofins: !!value })}
              />
            </div>
            <div className="form-group">
              <p className="margin-bottom-2"><Translate value="ipi" /></p>
              <Switch
                readOnly
                checked={ipi}
                className="margin-bottom-2"
                onChange={value => this.setState({ ipi: !!value })}
              />
            </div>
            <div className="form-group">
              <p className="margin-bottom-2"><Translate value="proEmprego" /></p>
              <Switch
                readOnly
                checked={proEmprego}
                className="margin-bottom-2"
                onChange={value => this.setState({ proEmprego: !!value })}
              />
            </div>
          </div>
        )}
        <div className="form-group">
          <p className="margin-bottom-2"><Translate value="clientId" /></p>
          <input
            readOnly
            type="text"
            className="form-control"
            placeholder=""
            value={codEmitente || ''}
          />
        </div>
        <div className="form-group">
          <p className="margin-bottom-2"><Translate value="contactId" /></p>
          <input
            readOnly
            type="text"
            className="form-control"
            placeholder=""
            value={idContato || ''}
          />
        </div>
        <div className="form-group">
          <p className="margin-bottom-2"><Translate value="registerDate" /></p>
          <input
            readOnly
            type="text"
            className="form-control"
            placeholder=""
            value={createdAt || ''}
          />
        </div>
        <div className="form-group">
          <p className="margin-bottom-2"><Translate value="registerUpdated" /></p>
          <input
            readOnly
            type="text"
            className="form-control"
            placeholder=""
            value={updatedAt || ''}
          />
        </div>
      </React.Fragment>
    );
  }

  goBack = () => {
    history.push({ pathname: ROUTES.REGISTER_MONITOR });
  }

  render() {
    const { location } = this.props;
    const { success, message } = this.state;
    if (!(location && location.item)) return null;

    return (
      <div className="main-table">
        <div className="main-header-table">
          <HeaderComponent
            title={I18n.t('edit')}
          />
          <div className="margin-top-20 ">
            {this.renderForm()}
            <div className="row margin-left-0">
              <button
                type="button"
                onClick={this.goBack}
                className="btn btn-warning margin-right-15"
              >
                <Translate value="return" />
              </button>
              <div>
                <button
                  type="button"
                  className="btn btn-dark"
                  onClick={this.updateNewRegister}
                >
                  <Translate value="update" />
                </button>
              </div>
            </div>
            {success && <p className="color-green margin-top-10">{success}</p>}
            {message && <p className="color-red margin-top-10">{message}</p>}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  settings: state.settings,
});

const mapDispatchToProps = dispatch => ({
  updateNewRegister: newRegister => dispatch(NewRegistersAction.updateNewRegister(newRegister)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RegisterMonitorEdit);
